import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import ibmLogo from '../assets/images/logo.png';

export interface BVAResultsProps {
  imgResults: string;
  imgSummary: string;
  pdfPara1: string;
  pdfPara2: string;
  pdfPara3: string;
  pdfPara4: string;
  pdfPara5: string;
  pdfPara6: string;
  pdfPara7: string;
  heading: string;
}

export const PDFGenerate = ({
  imgResults,
  imgSummary,
  pdfPara1,
  pdfPara2,
  pdfPara3,
  pdfPara4,
  pdfPara5,
  pdfPara6,
  pdfPara7,
  heading,
}: BVAResultsProps) => {
  const styles = StyleSheet.create({
    page: { backgroundColor: '#fff' },
    section: { fontSize: 12, textAlign: 'justify', margin: 50 },
    paragraph: { paddingTop: 20 },
    paragraphItalics: { fontStyle: 'italic', paddingTop: 20 },
    image: { width: 100, height: 50 },
    imageForResults: { width: 350, height: 250, paddingTop: 10 },
    imageForSummary: {
      width: 180,
      height: 300,
      marginLeft: 315,
      marginTop: -240,
    },
    results: { paddingTop: 10 },
    sectionForSummary: { flexDirection: 'column' },
  });
  const paragraphs = [
    pdfPara1,
    pdfPara2,
    pdfPara3,
    pdfPara4,
    pdfPara5,
    pdfPara6,
  ];

  Font.registerHyphenationCallback((word) => [word]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Image style={styles.image} src={ibmLogo} />
          {paragraphs.map((paragraph, index) => (
            <Text style={styles.paragraph} key={index}>
              {paragraph}
            </Text>
          ))}
          <Text style={styles.paragraph}>{heading}</Text>
          <Image style={styles.imageForResults} src={imgResults} />
          <Image style={styles.imageForSummary} src={imgSummary} />
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.paragraph}>{pdfPara7}</Text>
        </View>
      </Page>
    </Document>
  );
};
